import type { MonthRangeValue, MonthState, PeriodMonth } from "./types-month-range-picker";

export const MONTH_NAMES = [
  "janeiro",
  "fevereiro",
  "março",
  "abril",
  "maio",
  "junho",
  "julho",
  "agosto",
  "setembro",
  "outubro",
  "novembro",
  "dezembro",
];
export const MONTH_SHORT = [
  "jan",
  "fev",
  "mar",
  "abr",
  "mai",
  "jun",
  "jul",
  "ago",
  "set",
  "out",
  "nov",
  "dez",
];
const RANGE_ERROR = "O mês inicial deve ser anterior ou igual ao final.";

export const monthIndex = ({ year, month }: PeriodMonth) => year * 12 + month - 1;
export const pad = (month: number) => String(month).padStart(2, "0");

/** `jan/2026`. */
export function formatMonth({ year, month }: PeriodMonth): string {
  return `${MONTH_SHORT[month - 1]}/${year}`;
}

/** Rótulo do botão: `jan/2026 – dez/2026`. */
export function formatMonthRangeLabel({ from, to }: MonthRangeValue): string {
  return `${formatMonth(from)} – ${formatMonth(to)}`;
}

/** Mensagem de erro de um intervalo com início depois do fim; `null` quando válido. */
export function validateMonthRange({ from, to }: MonthRangeValue): string | null {
  return monthIndex(from) > monthIndex(to) ? RANGE_ERROR : null;
}

export function stateOf(month: PeriodMonth, range: MonthRangeValue): MonthState {
  const index = monthIndex(month);
  const start = monthIndex(range.from);
  const end = monthIndex(range.to);
  if (index === start && index === end) return "single";
  if (index === start) return "start";
  if (index === end) return "end";
  return index > start && index < end ? "in-range" : "idle";
}
